import React, { useMemo } from 'react';
import Modal, { ModalBody, ModalHeader, ModalTitle } from '../../bootstrap/Modal';
import Button from '../../bootstrap/Button';
import Card, { CardBody, CardSubTitle, CardTitle } from '../../bootstrap/Card';
import TableCustom from '../../MyCustom/TableCustom';

const formatAnswerValue = (value) => {
  if (value === true) return 'Sim';
  if (value === false) return 'Não';
  if (Array.isArray(value)) return value.join(', ');
  if (value === undefined || value === null || value === '') return 'Não informado';
  return String(value);
};

const ModalViewAnswers = ({ itemSelected, open, setIsOpen, setIsClose }) => {
  const answerRows = useMemo(() => {
    return (itemSelected?.items || []).map((item, index) => ({
      id: item.id || `${itemSelected?.id}-${index}`,
      question: item.question_label || item.label || item.question || `Pergunta ${index + 1}`,
      value: formatAnswerValue(item.value),
    }));
  }, [itemSelected]);

  const columns = useMemo(() => ([
    {
      label: 'Pergunta',
      field: 'question',
    },
    {
      label: 'Resposta',
      field: 'value',
    },
  ]), []);

  return (
    <Modal
      id='modal-feedback-answers'
      titleId='modal-feedback-answers-title'
      isOpen={open}
      setIsOpen={setIsOpen}
      isStaticBackdrop
      isCentered
      size='xl'
      isAnimation>
      <ModalHeader setIsOpen={setIsOpen}>
        <ModalTitle id='modal-feedback-answers-title'>Respostas do feedback</ModalTitle>
      </ModalHeader>
      <ModalBody>
        <Card className='border-0 shadow-none'>
          <CardBody className='p-0'>
            <CardTitle tag='h4' className='mb-1'>
              {itemSelected?.customerName || 'Cliente não informado'}
            </CardTitle>
            <CardSubTitle tag='p' className='mb-1'>
              {itemSelected?.customerPhone || 'WhatsApp não informado'}
            </CardSubTitle>
            <CardSubTitle tag='p' className='mb-4'>
              {itemSelected?.createdAtLabel || 'Data não informada'}
            </CardSubTitle>

            <TableCustom
              columns={columns}
              rows={answerRows}
              keyExtractor={(row) => row.id}
              fileName='Feedback-Respostas'
              noShowPagination
            />

            <div className='d-flex flex-row-reverse mt-3'>
              <Button color='danger' icon='cancel' shadow='sm' hoverShadow='sm' size='sm' onClick={setIsClose}>
                Fechar
              </Button>
            </div>
          </CardBody>
        </Card>
      </ModalBody>
    </Modal>
  );
};

export default ModalViewAnswers;
